import React from "react";

import LegalPage from "views/legal/LegalPage";

const sections = [
  {
    title: "1. Kapsam",
    paragraphs: [
      "Bu Gizlilik Politikası, Destinasyon 360 web uygulamasını, mobil uygulama deneyimini ve Karadeniz destinasyonları, işletmeler, fırsatlar, rezervasyonlar, favoriler ve bildirimler gibi hizmet alanlarını kapsar.",
      "Platformu ziyaret eden, üyelik oluşturan, rezervasyon talebi gönderen, işletme profili yöneten veya yönetim paneli kullanan herkes bu politika kapsamındadır.",
    ],
  },
  {
    title: "2. Topladığımız Bilgiler",
    items: [
      "Kimlik ve iletişim bilgileri: ad, soyad, e-posta adresi, telefon numarası ve hesap görüntü adı.",
      "Hesap ve işlem bilgileri: üyelik rolü, rezervasyon talepleri, ödeme/abonelik durumları, favoriler, kayıtlı işletmeler ve bildirim tercihleri.",
      "İşletme bilgileri: işletme adı, kategori, konum, iletişim kanalları, açıklama, görseller, kampanya ve fırsat içerikleri.",
      "Teknik bilgiler: cihaz, tarayıcı, oturum, yaklaşık konum, IP adresi, hata kayıtları ve güvenlik günlükleri.",
      "Kullanım verileri: ziyaret edilen sayfalar, arama ve filtreleme tercihleri, harita etkileşimleri ve platform içi tıklamalar.",
    ],
  },
  {
    title: "3. Bilgileri Kullanma Amaçlarımız",
    items: [
      "Karadeniz destinasyonlarını, işletmeleri ve fırsatları kişiselleştirilmiş şekilde sunmak.",
      "Rezervasyon, bildirim, favori ve işletme yönetimi özelliklerini çalıştırmak.",
      "Kullanıcı desteği sağlamak, talepleri yanıtlamak ve hizmet kalitesini artırmak.",
      "Platform güvenliğini sağlamak, kötüye kullanımı önlemek ve hesap erişimini korumak.",
      "Yasal yükümlülükleri yerine getirmek ve gerektiğinde yetkili kurumlarla iletişim kurmak.",
    ],
  },
  {
    title: "4. Çerezler ve Benzer Teknolojiler",
    paragraphs: [
      "Destinasyon 360, oturumun devamlılığı, güvenlik, tercihlerin hatırlanması ve kullanım performansının ölçülmesi için çerezler ve benzer yerel depolama teknolojileri kullanabilir.",
      "Tarayıcı ayarlarınızdan çerezleri yönetebilirsiniz. Bazı çerezleri devre dışı bırakmanız, giriş, rezervasyon veya panel özelliklerinin beklenen şekilde çalışmasını etkileyebilir.",
    ],
  },
  {
    title: "5. Bilgilerin Paylaşılması",
    paragraphs: [
      "Kişisel verileriniz satılmaz. Veriler yalnızca hizmetin sunulması için gerekli olan teknoloji sağlayıcıları, ödeme/abonelik altyapıları, harita servisleri, analiz araçları, işletme/partner tarafları ve yasal zorunluluk bulunan kurumlarla sınırlı şekilde paylaşılabilir.",
      "Rezervasyon veya iletişim talebi oluşturduğunuzda, ilgili işletmenin talebi yanıtlayabilmesi için gerekli bilgiler işletme ile paylaşılabilir.",
    ],
  },
  {
    title: "6. Saklama Süresi",
    paragraphs: [
      "Veriler, hesabınız aktif olduğu sürece veya hizmetin sunulması, güvenlik, muhasebe, uyuşmazlık çözümü ve yasal yükümlülükler için gerekli olan süre boyunca saklanır.",
      "Saklama amacı sona erdiğinde veriler silinir, anonim hale getirilir veya yasal gerekliliklere uygun biçimde arşivlenir.",
    ],
  },
  {
    title: "7. Güvenlik",
    paragraphs: [
      "Verilerin korunması için erişim yetkilendirmesi, güvenli oturum yönetimi, düzenli kayıt incelemeleri ve makul teknik/organizasyonel önlemler uygulanır.",
      "İnternet üzerinden yapılan hiçbir aktarım tamamen risksiz değildir. Bu nedenle hesabınız için güçlü şifre kullanmanızı ve erişim bilgilerinizi üçüncü kişilerle paylaşmamanızı öneririz.",
    ],
  },
  {
    title: "8. İletişim",
    paragraphs: [
      "Bu politika hakkında soru, düzeltme veya silme talebiniz varsa destek@destinasyon360.com adresine yazabilir veya https://destinasyon360.com/destek sayfasındaki iletişim kanallarını kullanabilirsiniz.",
    ],
  },
];

const PrivacyPolicy = () => (
  <LegalPage
    title="Gizlilik Politikası"
    subtitle="Destinasyon 360 hizmetlerinde verilerin nasıl toplandığını, kullanıldığını ve korunduğunu açıklar."
    lastUpdated="12 Mayıs 2026"
    intro="Destinasyon 360; Karadeniz bölgesindeki şehirleri, işletmeleri, kampanyaları ve seyahat deneyimlerini kullanıcılarla buluşturan bir keşif ve yönetim platformudur. Gizliliğiniz bizim için önemlidir."
    sections={sections}
  />
);

export default PrivacyPolicy;
